import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { User, UserClass } from '../interface/user.interface';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AbstractControl, ValidationErrors } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  api = environment.apiUlr;
  datos: UserClass[] = [];
  respuesta?: boolean = false;
  id_suc: any = '';
  data = {};
  constructor(private httpC: HttpClient, private router: Router) {}

 getToken(){
   return  new HttpHeaders({
    'Content-Type': 'application/json',
    Authorization: `Bearer ${localStorage.getItem('token')}`,
  }); 

 }


  onLogin(user: any) {
    this.id_suc = localStorage.getItem('sucursal');
    return this.httpC.post<User>(`${this.api}login.php`, user).pipe(
      map((resp: any) => {
        if (resp.success) {
          this.saveToken(resp.token);
          this.router.navigate(['/home/menu' , this.id_suc|| 'default']);
          return resp.success;
        } else {
          return false;
        }
      })
    );
  }
  onRegister(user: any) {
    return this.httpC.post(`${this.api}register.php`, user);
  }

  OnUser() {
    return this.httpC.get<User>(`${this.api}user-info.php`, {
      headers: this.getToken(),
    });
  }

  saveToken(token: any) {
    localStorage.setItem('token', token);
  }

  close() {
    localStorage.removeItem('token');
    this.router.navigate(['./sucursales']);
  }
  isAutenticate() {
    this.OnUser().subscribe((resp) => {
      this.respuesta=resp.success;
    });
    return this.respuesta;
  }

  checkoutSuccesfull(
    detail: any,
    price: number,
    id_suc: any,
    items: any,
    n_empresa: any,
    mensaje: any,
    telefono: any
  ) {
  
    this.data = {
      id_sucursal: id_suc,
      request_paypal: detail,
      products: items,
      total: price,
      name_empresa: n_empresa,
      mensaje: mensaje,
      telefono: telefono,
    };

    return this.httpC.post(`${this.api}checkout.php`, this.data, {
      headers: this.getToken(),
    });
  }

  getOrders() {

    return this.httpC.get(`${this.api}/orders.php`, { headers: this.getToken()});
  }

  getDetTicket(id_tk: any) {

    this.data = {
      tk_detalle: id_tk,
    };

    return this.httpC.post(`${this.api}orders_det.php`, this.data, {
      headers: this.getToken(),
    });
  }

  renewToken(){
    return this.httpC.get(`${this.api}r_token.php`,{headers:this.getToken()}).pipe(
      map((resp: any) => {
        if (resp.success) {
          this.saveToken(resp.token);
          return resp.success;
        } else {
          return false;
        }
      })
    );
  }



  matchInputs(input1:string, input2:string){
return(formGroup:AbstractControl):ValidationErrors | null=>{
  const pass1 = formGroup.get(input1)?.value;
  const pass2 = formGroup.get(input2)?.value;
  if (pass1 !== pass2) {
    formGroup.get(input2)?.setErrors({ noMatch:true });
    return { noMatch:true }
  }
  formGroup.get(input2)?.setErrors(null);
    return null;
    }
  }

 cancelarPedido(ticket:any){ 
  this.data = { 
    id_ticket: ticket.tk_id
  };

   return this.httpC.post(`${this.api}cancel_p.php`,this.data, {headers: this.getToken()}); 
 }

 getMinPay(){
   return this.httpC.get(`${this.api}get_det_gen.php`).pipe(
     map((resp: any) =>{
       if (resp.success) {
         return resp.datos;
       } else {
         return [];
       }
     })
   )
 }
}
